import React from 'react';
import { Table, Avatar, Badge, Button } from '@/components/ui';
import type { ConstructionSchedule } from '../types/construction-schedules.types';
import { ScheduleStatusBadge } from './ScheduleStatusBadge';
import { useNavigate } from 'react-router-dom';

interface Props {
  data: ConstructionSchedule[];
  isLoading?: boolean;
}

export const ScheduleTable: React.FC<Props> = ({ data, isLoading }) => {
  const navigate = useNavigate();

  const columns = [
    { key: 'schedule_code', title: 'Mã lịch', width: '100px' },
    { key: 'title', title: 'Nội dung kế hoạch' },
    { key: 'project', title: 'Dự án / Giai đoạn' },
    { key: 'dates', title: 'Thời gian', width: '220px' },
    { key: 'team', title: 'Đội thi công' },
    { key: 'status_code', title: 'Trạng thái', width: '140px' },
    { key: 'actions', title: '', width: '80px', align: 'right' as const },
  ];

  return (
    <Table
      columns={columns}
      data={data}
      isLoading={isLoading}
      renderCell={(row, key) => {
        if (key === 'schedule_code') return <span className="text-xs font-bold text-slate-400">{row.schedule_code}</span>;
        if (key === 'title') return (
          <div className="space-y-1">
            <p className="text-xs font-bold text-slate-900">{row.title}</p>
            <p className="text-[10px] text-slate-400  tracking-tight font-medium">{row.work_type}</p>
          </div>
        );
        if (key === 'project') return (
          <div className="space-y-1">
            <p className="text-xs text-slate-700">{row.project?.name}</p>
            <p className="text-[10px] text-slate-400">{row.phase?.name || '---'}</p>
          </div>
        );
        if (key === 'dates') return (
          <div className="flex items-center gap-2 text-[10px] font-bold text-slate-500">
             <span>{row.scheduled_start_date}</span>
             <i className="ri-arrow-right-s-line text-slate-300" />
             <span>{row.scheduled_end_date}</span>
          </div>
        );
        if (key === 'team') return (
          <div className="flex items-center gap-2">
             <div className="w-6 h-6 rounded-lg bg-slate-100 flex items-center justify-center text-[10px] font-bold text-slate-400">
               {row.team?.code?.substring(0, 2)}
             </div>
             <span className="text-xs text-slate-600">{row.team?.name}</span>
          </div>
        );
        if (key === 'status_code') return <ScheduleStatusBadge status={row.status_code} />;
        if (key === 'actions') return (
          <Button
            variant="ghost"
            size="xs"
            icon="ri-layout-right-line"
            onClick={() => navigate(`/construction/schedules/detail/${row.id}`)}
          />
        );
        return null;
      }}
    />
  );
};
